import React from 'react';
import { FileText } from 'lucide-react';
import styles from '../../styles/institutional.module.css';

const SECTIONS = [
    {
        title: '1. Aceitação dos termos',
        content: 'Ao criar uma conta no Orçamento Digital, você concorda integralmente com estes Termos de Uso. Se não concordar com qualquer parte destes termos, não utilize o serviço. O uso continuado após alterações nos termos implica aceitação das mudanças.',
        list: null,
    },
    {
        title: '2. Descrição do serviço',
        content: 'O Orçamento Digital é uma plataforma online de geração e gerenciamento de notas de serviço voltada para freelancers e pequenas empresas brasileiras. O serviço inclui:',
        list: [
            'Criação e armazenamento de notas de serviço',
            'Cálculo automático de impostos (ISS, IRRF, CSLL, COFINS, PIS)',
            'Geração de PDF das notas',
            'Gerenciamento de estoque de produtos e serviços',
            'Backup automático dos dados',
            'Acesso via aplicativo Android',
        ],
    },
    {
        title: '3. Planos e pagamentos',
        content: null,
        list: [
            'Plano Gratuito: 1 nota por semana, sem custo',
            'Plano Plus (R$ 12,90/mês): até 5 notas por semana, recursos avançados',
            'Plano Premium (R$ 21,90/mês): notas ilimitadas, todos os recursos',
            'Os pagamentos são processados pelo Mercado Pago com segurança',
            'Planos pagos são cobrados mensalmente e podem ser cancelados a qualquer momento',
            'Não há reembolso proporcional por cancelamento antes do fim do período',
        ],
    },
    {
        title: '4. Responsabilidades do usuário',
        content: 'Ao utilizar o Orçamento Digital, você se compromete a:',
        list: [
            'Fornecer informações verdadeiras e atualizadas no cadastro',
            'Manter a segurança das suas credenciais de acesso',
            'Não compartilhar sua conta com terceiros',
            'Usar o serviço apenas para fins legais e legítimos',
            'Não tentar burlar os limites do plano contratado',
            'Responsabilizar-se pela veracidade das notas emitidas',
        ],
    },
    {
        title: '5. Limitações de responsabilidade',
        content: 'O Orçamento Digital é uma ferramenta de apoio à geração de documentos. Não nos responsabilizamos por:',
        list: [
            'Obrigações fiscais decorrentes do uso das notas emitidas',
            'Erros em dados inseridos pelo próprio usuário',
            'Indisponibilidades temporárias do serviço por manutenção',
            'Perdas decorrentes de uso indevido das credenciais de acesso',
            'Adequação das notas geradas às exigências específicas de cada município',
        ],
    },
    {
        title: '6. Propriedade intelectual',
        content: 'O Orçamento Digital, seu código, design, marca e logotipo são propriedade exclusiva dos seus desenvolvedores. É proibido copiar, modificar, distribuir ou criar obras derivadas sem autorização expressa. Os dados e documentos gerados por você pertencem a você.',
        list: null,
    },
    {
        title: '7. Suspensão e encerramento',
        content: 'Nos reservamos o direito de suspender ou encerrar contas que violem estes termos, sem aviso prévio em casos graves. Em situações ordinárias, o usuário será notificado por e-mail antes de qualquer ação.',
        list: null,
    },
    {
        title: '8. Alterações nos termos',
        content: 'Podemos atualizar estes Termos de Uso a qualquer momento. Alterações significativas serão comunicadas por e-mail com pelo menos 15 dias de antecedência. O uso continuado do serviço após esse prazo implica aceitação.',
        list: null,
    },
    {
        title: '9. Lei aplicável',
        content: 'Estes termos são regidos pela legislação brasileira. Quaisquer disputas serão submetidas ao foro da comarca de São Paulo - SP, com renúncia a qualquer outro, por mais privilegiado que seja.',
        list: null,
    },
    {
        title: '10. Contato',
        content: 'Dúvidas sobre estes termos: termos@notafacil.com.br',
        list: null,
    },
];

export default function Termos() {
    return (
        <div className={styles.page}>
            <div className={styles.proseWrap}>

                {/* Header */}
                <div className={styles.proseHero}>
                    <div className={styles.proseBadge}>
                        <FileText size={11} style={{ display:'inline', marginRight:'4px', verticalAlign:'middle' }} />
                        Termos de Uso
                    </div>
                    <h1 className={styles.proseTitle}>Termos e condições de uso</h1>
                    <p className={styles.proseDate}>Última atualização: Janeiro de 2025 · Versão 1.0</p>
                </div>

                <div className={styles.proseBody}>
                    <p className={styles.proseHighlight}>
                        Leia com atenção antes de criar sua conta. Estes termos estabelecem os direitos e
                        responsabilidades de todos que utilizam o Orçamento Digital.
                    </p>

                    {SECTIONS.map((section, i) => (
                        <div key={i} className={styles.proseSection}>
                            <h2 className={styles.proseSectionTitle}>{section.title}</h2>
                            {section.content && (
                                <p className={styles.proseText}>{section.content}</p>
                            )}
                            {section.list && (
                                <ul className={styles.proseList}>
                                    {section.list.map((item, j) => (
                                        <li key={j}>{item}</li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    ))}
                </div>

            </div>
        </div>
    );
}